import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../../../actions/ApiGo';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../../stores/reducer_add';
import { DF } from '../../../dashboard/DashFunction';

const ConnectionList = (props) => {
  const { t, i18n } = useTranslation()
  const row_header = [
    t("GLOBAL.NAME"),
    t("GLOBAL.IP"),
    t("GLOBAL.DEVICE_OS"),
    t("GLOBAL.ONLINE_STATUS"),
    t("AUDIT_TRAIL.EVENTS.LOGIN") + t("GLOBAL.TIME"),
    t("AUDIT_TRAIL.EVENTS.LOGOUT") + t("GLOBAL.TIME"),
    t("GLOBAL.FORCED_LOGOUT")
  ]
  const [userData, setUserData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  function toggleRefresh() { setRefresh(!refresh) }
  const [connectionRow, setConnectionRow] = useState([]);
  const store_users_array = useSelector(state => state.store_users.orign_users_array)
  const dispatch = useDispatch()
  const connection_check = props.mos.connectionCheck;

  useEffect(() => {
    ApiGo.getUsers()
      .then(res => { setUserData(res.users) })
      .catch(err => { console.log(err); })

    ApiGo.getDevice_connection_latest_status()
      .then(res => { setConnectionRow(res) })
      .catch(err => { console.log(err); })

    ApiGo.check_close_browser_refresh()

    return (() => {
      setUserData([])
      setConnectionRow([])
    })
  }, [refresh, connection_check]);

  function dismissUser(_id, _flag) {
    let user = userData.filter(res => res.id === _id)[0]
    if (user.role === "admin") {
      dispatch(ADD_RESPONSE({
        status: 666,
        statusText: "success",
        type: "dismiss_user"
      }))
      return
    }
    ApiGo.updateActivationUser(user.email, _flag)
      .then(() => {
        dispatch(ADD_RESPONSE({
          status: 200,
          statusText: "success",
          type: (_flag === 0) ? "dismiss_user" : "restore_user"
        }))
        toggleRefresh()
      })
      .catch(err => {
        dispatch(ADD_RESPONSE({
          status: err.status,
          statusText: err.statusText,
          type: (_flag === 0) ? "dismiss_user" : "restore_user"
        }))
        return err.response
      })
      .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
  }

  function state_logout(_id) {
    let user = userData.filter(res => res.id === _id)[0]
    let activation = (user !== undefined && user !== null) ? user.activation : 1
    if (activation === 0) { return { msg: t("ADMIN.FORCED_LOGOUT_MSG"), activate: false } }
    return { msg: "", activate: true }
  }

  function loginStatus(inTime, outTime, _id) {
    if (!state_logout(_id).activate) { return 'out' }
    let t1 = new Date(inTime).getTime()
    let t2 = new Date(outTime).getTime()
    return (t1 > t2) ? 'in' : "out"
  }

  function splitTime(_t) {
    let now = new Date()
    let _time = new Date(_t)
    if (_t === null) return ['', t("GLOBAL.NOT_LOGGED_OUT")]
    if (now.getDate() !== _time.getDate()) {
      return _t.split("T")
    }
    else {
      return [t("GLOBAL.TODAY"), _t.split("T")[1]]
    }
  }

  // helper: 把毫秒差轉成「x秒前 / x分前 / x小時前 / x天前」的本地化字串
  function timeAgoText(deltaMs) {
    const seconds = Math.floor(deltaMs / 1000)
    if (seconds < 60) {
      return `${seconds}${t("TIME.SECONDS_SUFFIX")}` // e.g. "5 秒前"
    }
    const minutes = Math.floor(deltaMs / 60000)
    if (minutes < 60) {
      return `${minutes}${t("TIME.MINUTES_SUFFIX")}` // e.g. "3 分前"
    }
    const hours = Math.floor(deltaMs / 3600000)
    if (hours < 24) {
      return `${hours}${t("TIME.HOURS_SUFFIX")}` // e.g. "2 小時前"
    }
    const days = Math.floor(hours / 24)
    return `${days}${t("TIME.DAYS_SUFFIX")}` // e.g. "1 天前"
  }

  function handleLoginTime(inTime, _id, outTime) {
    if (!state_logout(_id).activate) { return state_logout(_id).msg }
    if (inTime === null) return "-"
    let t1 = new Date(inTime).getTime()
    let t2 = new Date(outTime).getTime()
    if (t1 > t2) return t("GLOBAL.ONLINE") // 上線中
    let now = new Date()
    let _intime = new Date(inTime)
    let _deltaTime = now.getTime() - _intime.getTime()
    return timeAgoText(_deltaTime)
  }

  function handleCloseTime(closeTime, _id) {
    if (!state_logout(_id).activate) { return state_logout(_id).msg }
    if (closeTime === null) return [t("GLOBAL.ONLINE"), ""] // 上線中
    let t1 = new Date(closeTime).getTime()
    let now = new Date()
    let _deltaTime = now.getTime() - t1
    const agoText = timeAgoText(_deltaTime)
    return [agoText, t("GLOBAL.OFFLINE")] // e.g. ["3 分前", "離線"]
  }

  let div = <div className='fx-d-c bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-15 t b margb-xxs'>
    <div className='font-l margl-xxs margb-xxs'>{t("ADMIN.CURRENT_CONNECTED_ACCOUNT")}</div>

    <div className='w-100 fx-d-r fx-cspar'>{row_header.map((res, index) =>
      <div key={index} className={`${
        (index === 6) ? "w-10" :
          (index === 0) ? "w-5" : "w-15"
      } fx-ccc h-100 font-ml`} >{res}
      </div>)}</div>
    {connectionRow.map((user, index) => <div className='w-100 font-ml fx-d-r fx-cspar pad-15 t b row_hover' key={index}>
      <div className='w-5 fx-ccc'>{user.user_name}</div>
      <div className="w-15 fx-ccc">{user.client_ip}</div>
      <div className="w-15 fx-d-c fx-ccc">
        <div>{DF.abbreviate(user.type, "all")}</div>
        <div>{DF.abbreviate(user.os, 12)}</div>
      </div>
      <div className="w-15 fx-ccc">
        <div className='w-30 fx-d-r fx-fec'>
          <div className={`loginCircle ${loginStatus(user.verify_time, user.close_time, user.user_id)}`}></div>
        </div>
        <div className="w-70 fx-d-c fx-ccc">
          <div className='fx-ccc'>{handleCloseTime(user.close_time, user.user_id)[0]}</div>
          <div className='font-m'>{handleCloseTime(user.close_time, user.user_id)[1]}</div>
        </div>
      </div>
      <div className="w-15 fx-d-c fx-ccc">
        <div>{splitTime(user.login_time)[1]}</div>
        <div className='font-m'>{splitTime(user.login_time)[0]}</div>
      </div>
      <div className="w-15 fx-d-c fx-ccc">
        <div>{splitTime(user.last_logout_time)[1]}</div>
        <div className='font-m'>{splitTime(user.last_logout_time)[0]}</div>
      </div>
      <div className=' w-10 fx-ccc'>
        {(state_logout(user.user_id).activate) ?
          <div onClick={() => { dismissUser(user.user_id, 0) }}
            className='bgC-alert-EE br-5 pad-15 l r shadow-xs cursor pt margl-xs'>
            {t("AUDIT_TRAIL.EVENTS.LOGOUT")}
          </div> :
          <div onClick={() => { dismissUser(user.user_id, 1) }}
            className='bgC-alert-E br-5 pad-15 l r shadow-xs cursor pt margl-xs'>
            {t("ADMIN.RESTORE_USER")}
          </div>
        }
      </div>
    </div>)}
  </div>

  return (
    <div className='w-100 fx-d-c'>
      <div className='wid-admin-90 fx-d-r fx-fec'>
        <div className='fx-ccc font-m bgC-alert-E pad-5 l b r t cursor pt br-10 shadow-xs margb-xxxs LRefresh' onClick={toggleRefresh}>
          <div className='tag search fx-cspar font-ml pad-5 l r'>
            <div className='refreshFrame'>
              <div className='layoutRefresh_sass clickRotate fx-d-r'>
                <div className="reloadSingle"></div>
              </div>
            </div>
          </div>
          {t("ADMIN.INDEX.REFRESH")}
        </div>
      </div>
      {div}
    </div>
  );
}
export default ConnectionList;